export default __webpack_public_path__ + "static/media/kirk_nugent.7349b3a5.png";